export const HEIC_MIME_TYPES = new Set(['image/heic', 'image/heif']);

export async function ensureWebSafeImage(file: File): Promise<File> {
  if (!isHeicLike(file)) return file;

  const { heicTo } = await import('heic-to');
  const jpegBlob = await heicTo({
    blob: file,
    type: 'image/jpeg',
    quality: 0.85,
  });

  const newName = `${file.name.replace(/\.(heic|heif)$/i, '')}.jpg`;
  return new File([jpegBlob], newName, { type: 'image/jpeg' });
}

function isHeicLike(file: File): boolean {
  return HEIC_MIME_TYPES.has(file.type.toLowerCase());
}
